



























































































































































































































































































































































































































































































































































































































































































import Vue, { PropType } from "vue";
import Locale from "@/service/Locale/Locale";

import {
  extend,
  localize,
  ValidationObserver,
  ValidationProvider
} from "vee-validate";
import {
  confirmed,
  email,
  max,
  numeric,
  required
} from "vee-validate/dist/rules";

extend("required", required);
extend("confirmed", confirmed);
extend("numeric", numeric);
extend("email", email);
extend("max", max);

interface InquiryValidationProps {
  actionUrl: string;
  csrfToken: string;
  lang: any;
  maxErrorText: string;
  emailErrorText: string;
  requiredErrorText: string;
  locale: string;
  countries: any;
  name: string;
  mailAddress: string;
  clipUserMailAddress: string;
  clipHandleName: string;
  cancellationGrades: string[];
  cancellationPlans: string[];
  contractNumberForSingledDevicePlan: string;
  contractNumberForDualDevicePlan: string;
  contractNumberForPremiumPlan: string;
  contractNumberForSmartphonePlan: string;
  paymentTerm: string[];
  paypalMailAddress: string;
  cancellationReason: string;
  cancellationDesiredDate: string;
  specifiedDay: string;
}

interface InquiryValidationData {
  nameData: string;
  mailAddressData: string;
  clipUserMailAddressData: string;
  clipHandleNameData: string;
  cancellationGradesData: string[];
  cancellationPlansData: string[];
  contractNumberForSingledDevicePlanData: string;
  contractNumberForDualDevicePlanData: string;
  contractNumberForPremiumPlanData: string;
  contractNumberForSmartphonePlanData: string;
  paymentTermData: string[];
  paypalMailAddressData: string;
  agreeWithPrivacyPolicyData: string[];
  agreeWithCancellationData: string[];
  inputRule: string;
  notRequiredInputRule: string;
  requiredRule: string;
  radioRule: string;
  checkboxRule: string;
  mailAddressRule: string;
  nameMaxLength: number;
  mailAddressMaxLength: number;
  clipUserMailAddressMaxLength: number;
  clipHandleNameMaxLength: number;
  paypalMailAddressMaxLength: number;
  namePlaceholder: string;
  mailAddressPlaceholder: string;
  clipUserMailAddressPlaceholder: string;
  clipUserMailAddressInfo: string;
  clipHandleNamePlaceholder: string;
  clipHandleNameInfo: string;
  paypalMailAddressInfo: string;
  mailAddressInfo: string;
  cancellationReasonData: string;
  cancellationDesiredDateData: string;
  specifiedDayData: string;
  specifiedDayMaxLength: number;
  specifiedDayPlaceholder: string;
}

type Methods = {
  onSubmit: () => void;
  getCountryCode: () => string;
};

// FIXME 引数のanyを修正する
export default Vue.extend<any, Methods, any, any>({
  name: "vc-inquiry-validation",
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: {
    actionUrl: {
      type: String as PropType<InquiryValidationProps["actionUrl"]>,
      default: ""
    },
    csrfToken: {
      type: String as PropType<InquiryValidationProps["csrfToken"]>,
      default: ""
    },
    lang: {
      type: Object as PropType<InquiryValidationProps["lang"]>,
      default: () => {}
    },
    maxErrorText: {
      type: String as PropType<InquiryValidationProps["maxErrorText"]>,
      default: ""
    },
    emailErrorText: {
      type: String as PropType<InquiryValidationProps["emailErrorText"]>,
      default: ""
    },
    requiredErrorText: {
      type: String as PropType<InquiryValidationProps["requiredErrorText"]>,
      default: ""
    },
    locale: {
      type: String as PropType<InquiryValidationProps["locale"]>,
      default: ""
    },
    countries: {
      type: Array as PropType<InquiryValidationProps["countries"]>,
      default: () => []
    },
    name: {
      type: String as PropType<InquiryValidationProps["name"]>,
      default: ""
    },
    mailAddress: {
      type: String as PropType<InquiryValidationProps["mailAddress"]>,
      default: ""
    },
    clipUserMailAddress: {
      type: String as PropType<InquiryValidationProps["clipUserMailAddress"]>,
      default: ""
    },
    clipHandleName: {
      type: String as PropType<InquiryValidationProps["clipHandleName"]>,
      default: ""
    },
    cancellationGrades: {
      type: Array as PropType<InquiryValidationProps["cancellationGrades"]>,
      default: () => []
    },
    cancellationPlans: {
      type: Array as PropType<InquiryValidationProps["cancellationPlans"]>,
      default: () => []
    },
    contractNumberForSingledDevicePlan: {
      type: String as PropType<
        InquiryValidationProps["contractNumberForSingledDevicePlan"]
      >,
      default: ""
    },
    contractNumberForDualDevicePlan: {
      type: String as PropType<
        InquiryValidationProps["contractNumberForDualDevicePlan"]
      >,
      default: ""
    },
    contractNumberForPremiumPlan: {
      type: String as PropType<
        InquiryValidationProps["contractNumberForPremiumPlan"]
      >,
      default: ""
    },
    contractNumberForSmartphonePlan: {
      type: String as PropType<
        InquiryValidationProps["contractNumberForSmartphonePlan"]
      >,
      default: ""
    },
    paymentTerm: {
      type: Array as PropType<InquiryValidationProps["paymentTerm"]>,
      default: () => []
    },
    paypalMailAddress: {
      type: String as PropType<InquiryValidationProps["paypalMailAddress"]>,
      default: ""
    },
    cancellationReason: {
      type: String as PropType<InquiryValidationProps["cancellationReason"]>,
      default: ""
    },
    cancellationDesiredDate: {
      type: String as PropType<
        InquiryValidationProps["cancellationDesiredDate"]
      >,
      default: ""
    },
    specifiedDay: {
      type: String as PropType<InquiryValidationProps["specifiedDay"]>,
      default: ""
    }
  },
  data(): InquiryValidationData {
    return {
      nameData: this.name,
      mailAddressData: this.mailAddress,
      clipUserMailAddressData: this.clipUserMailAddress,
      clipHandleNameData: this.clipHandleName,
      cancellationGradesData: this.cancellationGrades || [],
      cancellationPlansData: this.cancellationPlans || [],
      contractNumberForSingledDevicePlanData: this
        .contractNumberForSingledDevicePlan,
      contractNumberForDualDevicePlanData: this.contractNumberForDualDevicePlan,
      contractNumberForPremiumPlanData: this.contractNumberForPremiumPlan,
      contractNumberForSmartphonePlanData: this.contractNumberForSmartphonePlan,
      paymentTermData: this.paymentTerm || [],
      paypalMailAddressData: this.paypalMailAddress,
      agreeWithPrivacyPolicyData: [],
      agreeWithCancellationData: [],
      inputRule: "required|max:",
      requiredRule: "required:true",
      notRequiredInputRule: "max:",
      radioRule: "required:true",
      checkboxRule: "required:true",
      mailAddressRule: "required|email|max:",
      nameMaxLength: 190,
      mailAddressMaxLength: 190,
      clipUserMailAddressMaxLength: 190,
      clipHandleNameMaxLength: 190,
      paypalMailAddressMaxLength: 190,
      namePlaceholder: this.lang.inquiry_form_info_1,
      mailAddressPlaceholder: this.lang.inquiry_form_info_1,
      clipUserMailAddressPlaceholder: this.lang.inquiry_form_info_1,
      clipUserMailAddressInfo: "*" + this.lang.inquiry_form_info_2,
      clipHandleNamePlaceholder: this.lang.inquiry_form_info_1,
      clipHandleNameInfo: "*" + this.lang.inquiry_form_info_2,
      paypalMailAddressInfo: this.lang.inquiry_form_info_3,
      mailAddressInfo: "*" + this.lang.inquiry_form_info_2,
      cancellationReasonData: this.cancellationReason,
      cancellationDesiredDateData: this.cancellationDesiredDate,
      specifiedDayData: this.specifiedDay,
      specifiedDayMaxLength: 190,
      specifiedDayPlaceholder: this.lang
        .inquiry_form_cancellation_desired_date_specified_day_placeholder
    };
  },
  mounted() {
    this.countryCodeData = this.countryCode || this.getCountryCode();
    const locale = Locale.getLocale();

    localize(locale, {
      messages: {},
      fields: {
        nameProvider: {
          required: this.requiredErrorText.replace(
            ":attribute",
            this.lang.inquiry_form_name
          ),
          max: this.maxErrorText
            .replace(":max", this.nameMaxLength)
            .replace(":attribute", this.lang.inquiry_form_name)
        },
        mailAddressProvider: {
          required: this.requiredErrorText.replace(
            ":attribute",
            this.lang.inquiry_form_mail_address
          ),
          email: this.emailErrorText.replace(
            ":attribute",
            this.lang.inquiry_form_mail_address
          ),
          max: this.maxErrorText
            .replace(":max", this.mailAddressMaxLength)
            .replace(":attribute", this.lang.inquiry_form_mail_address)
        },
        clipUserMailAddressProvider: {
          required: this.requiredErrorText.replace(
            ":attribute",
            this.lang.inquiry_form_mail_address_registered_in_CLIP_STUDIO
          ),
          max: this.maxErrorText
            .replace(":max", this.clipUserMailAddressMaxLength)
            .replace(
              ":attribute",
              this.lang.inquiry_form_mail_address_registered_in_CLIP_STUDIO
            )
        },
        clipHandleNameProvider: {
          required: this.requiredErrorText.replace(
            ":attribute",
            this.lang.inquiry_form_CLIP_STUDIO_handle_name
          ),
          max: this.maxErrorText
            .replace(":max", this.clipHandleNameMaxLength)
            .replace(
              ":attribute",
              this.lang.inquiry_form_CLIP_STUDIO_handle_name
            )
        },
        cancellationGradesProvider: {
          required: this.requiredErrorText.replace(
            ":attribute",
            this.lang.inquiry_form_cancellation_services
          )
        },
        cancellationPlansProvider: {
          required: this.requiredErrorText.replace(
            ":attribute",
            this.lang.inquiry_form_cancellation_plans
          )
        },
        paymentTermProvider: {
          required: this.requiredErrorText.replace(
            ":attribute",
            this.lang.inquiry_form_payment_term
          )
        },
        paypalMailAddressProvider: {
          required: this.requiredErrorText.replace(
            ":attribute",
            this.lang.inquiry_form_paypal_mail_address
          ),
          max: this.maxErrorText
            .replace(":max", this.paypalMailAddressMaxLength)
            .replace(":attribute", this.lang.inquiry_form_paypal_mail_address)
        },
        cancellationReasonProvider: {
          required: this.requiredErrorText.replace(
            ":attribute",
            this.lang.inquiry_form_cancellation_reason
          )
        },
        cancellationDesiredDateProvider: {
          required: this.requiredErrorText.replace(
            ":attribute",
            this.lang.inquiry_form_cancellation_desired_date
          )
        },
        specifiedDayProvider: {
          required: this.requiredErrorText.replace(
            ":attribute",
            this.lang.inquiry_form_cancellation_desired_date_specified_day
          ),
          max: this.maxErrorText.replace(":max", this.specifiedDayMaxLength)
        },
        agreeWithPrivacyPolicyDataProvider: {},
        agreeWithCancellationDataProvider: {}
      }
    });
  },
  computed: {
    firstCountryList() {
      return this.countries.filter((country: any) => {
        return country.display_list_priority === 1;
      });
    },
    secondCountryList() {
      return this.countries.filter((country: any) => {
        return country.display_list_priority === 2;
      });
    },
    parsedQuantityData() {
      return parseInt(
        this.displayQuantityData
          .replace(/[,.\x20\u3000]/g, "")
          .replace(/[０-９]/g, (num: string) =>
            String.fromCharCode(num.charCodeAt(0) - 0xfee0)
          )
      );
    },
    isGradesWithDevicePlans() {
      const isNullUndefined = this.cancellationGradesData == null;
      if (isNullUndefined) {
        return false;
      }
      if (
        this.cancellationGradesData.includes("pro") ||
        this.cancellationGradesData.includes("ex")
      ) {
        return true;
      }
      return false;
    },
    isCancellationDesiredDate() {
      // 契約終了予定日には以下の選択肢が存在する
      // option_1: なるべく早く
      // option_2: 指定の日で
      // option_3: 現在の契約期間終了時で
      // このうちoption_2であるかどうかを判定する

      const isNullUndefined = this.cancellationDesiredDateData == null;
      const chkValueString = "option_2";
      if (isNullUndefined) {
        return false;
      }
      if (this.cancellationDesiredDateData == chkValueString) {
        return true;
      }
      return false;
    }
  },
  methods: {
    onSubmit(): void {
      (this.$refs.form as HTMLFormElement).submit();
    },
    getCountryCode(): string {
      const locale = Locale.getLocale();
      if (locale === "ja-jp") {
        return "JPN";
      } else if (locale === "ko-kr") {
        return "KOR";
      } else if (locale === "zh-tw") {
        return "TWN";
      } else if (locale === "fr-fr") {
        return "FRA";
      } else if (locale === "de-de") {
        return "DEU";
      } else if (locale === "es-es") {
        return "ESP";
      } else {
        return "USA";
      }
    }
  }
});
